<!-- <Navbar /> -->
<div class="container px-8 py-5 lg:py-8 mx-auto xl:px-5 max-w-screen-lg">
  <nav>
    <div class="flex flex-wrap justify-between md:gap-10 md:flex-nowrap myup2">
      <div class="flex-col items-center justify-start order-1 hidden w-full md:flex md:flex-row md:justify-end md:w-auto md:order-none md:flex-1">

        <button class="myup2 text-sm ont-medium text-gray-600 dark:text-gray-400" mat-button [matMenuTriggerFor]="menu2">Calculators</button>
        <mat-menu #menu2="matMenu">
          <button routerLink="/gascalculator" mat-menu-item>Gascalculator</button>
          <button mat-menu-item routerLink="/aerocalculator">Aerocalculator</button>
          <button mat-menu-item routerLink="/rpecalculator">RPECalculator</button>
        </mat-menu>

        <!-- <span class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500" >
          Calculators
        </span> -->
        <a routerLink="/publications" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
          Publications
        </a>
        <a routerLink="/resume" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
          Resume
        </a>
      </div>

      <div class="flex items-center justify-between w-full md:w-auto">
        <span class="w-60">
          <img src="assets/logo.png" alt="">
        </span>

        <button id="menu" aria-label="Toggle Menu" class="px-2 py-1 ml-auto text-gray-500 rounded-md md:hidden focus:text-blue-500 focus:outline-none dark:text-gray-300">
          <svg class="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              class="navmenu-toggle"
              fill-rule="evenodd"
              d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"></path>

            <path
              class="navmenu-toggle hidden"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"></path>
          </svg>
        </button>
      </div>
      
      <div class="flex-col items-center justify-start order-2 hidden w-full md:flex md:flex-row md:w-auto md:flex-1 md:order-none">
        <a routerLink="/dimensionalanalysis" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
          Dimensional Analysis
        </a>
        <a routerLink="/propulsion" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
          Propulsion
        </a>
        <a routerLink="/thermodynamics" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
          Thermodynamics
        </a>

      </div>
    </div>
    <div class="navmenu-toggle hidden">
      <div class="flex flex-col items-center justify-start order-2 w-full md:hidden">   
        <a routerLink="/dimensionalanalysis" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
          Dimensional Analysis
        </a>

        <a routerLink="/propulsion" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
          Propulsion
        </a>


        <a routerLink="#" class="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-500">
            Thermodynamics
        </a>
      </div>
    </div>
  </nav>
</div>
 
<!-- end navbar -->


<!-- <slot /> -->


<router-outlet></router-outlet>



<!-- end slot  -->



  <!-- <Footer /> --> 
  <div class="mt-10 border-t border-gray-100 dark:border-gray-800">
    <footer class="flex flex-col items-center">
      <div class="text-sm text-center">
        Copyright
      </div>
      <div class="flex justify-center gap-1 mt-1 text-sm text-center text-gray-500 dark:text-gray-600">
        <span>
          made by bibs
        </span>
        <span>&middot;</span>
        <span>
          <a
            href="https://github.com/web3templates/stablo-astro"
            rel="noopener"
            target="_blank">
            Github
          </a>
        </span>
      </div>
    </footer>
  </div>
